import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Typography, Box } from '@mui/material';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';
import { secondsToTime } from '../../../../utils/formatTime';
// ----------------------------------------------------------------------

const RootStyle = styled(Card)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 10,
  flexWrap: 'wrap',
}));

// ----------------------------------------------------------------------

BookingWidgetSummary.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.string,
  total: PropTypes.number,
  time: PropTypes.any,
  text: PropTypes.string,
  color: PropTypes.string,
};

export default function BookingWidgetSummary({ title, total, icon, time, text, color }) {
  return (
    <RootStyle>
      <div style={{ padding: 10 }}>
        <Typography variant="h2">{fShortenNumber(total)}</Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>
      </div>
      <Box
        sx={{
          width: 80,
          height: 80,
          lineHeight: 0,
          borderRadius: '50%',
          bgcolor: 'background.neutral',
          padding: 2,
        }}
      >
        {icon}
      </Box>
      <Box
        sx={{
          width: '100%',
          height: 30,
          lineHeight: 0,
          borderRadius: '5px',
          bgcolor: color,
          marginTop: 2,
          padding: '5px',
        }}
      >
        <Typography variant="subtitle2" sx={{ color: '#fff', textAlign: 'center' }}>
          {time !== undefined ? (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p>Tempo médio: </p>
              <p>{secondsToTime(time)}</p>
            </div>
          ) : (
            text
          )}
        </Typography>
      </Box>
    </RootStyle>
  );
}
